import type { SVGProps } from 'react';
const SvgIconCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.198 3.602H2.8a.8.8 0 0 0-.8.8V13.2a.8.8 0 0 0 .8.8h10.398a.8.8 0 0 0 .8-.8V4.4a.8.8 0 0 0-.8-.8ZM2 6.797h11.997M5.203 4.8V2M10.797 4.8V2"
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    />
  </svg>
);
export default SvgIconCalendar;
